import { defineComponent as _defineComponent } from 'vue'
import {
  BaseText,
  ButtonPrimary,
  Heading,
  InputText,
  Link
} from '@warrenbrasil/nebraska-web';
import { computed, inject, ref, Ref } from 'vue';
import { ValidationError } from 'yup';
import { useRouter } from 'vue-router/composables';
import {
  SignInForm,
  YupError
} from '@/modules/authentication/views/SignIn/types';
import { InputStatusType } from '@/modules/onboarding/signup/types';
import { signinEmailSchema } from '@/modules/authentication/views/SignIn/helpers/validate';
import {
  trackEmailEvent,
  trackSignupLink
} from '@/modules/authentication/helpers/track-signin-events';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailFormStep',
  setup(__props) {

const setTheme = inject('setTheme') as (
  themeParam: string,
  paramType: 'domain' | 'email'
) => void;
const handleEmailSubmit = inject('handleEmailSubmit') as (
  email: string
) => void;
const errors = ref<YupError[]>([]);
const router = useRouter();
const isLoading = ref<boolean>(false);
const form = inject('form') as Ref<SignInForm>;

const disableButton = computed(() => errors.value.length > 0);

async function validate() {
  isLoading.value = true;
  try {
    clearErrors();
    await signinEmailSchema.validate(form.value, { abortEarly: false });
    setTheme(form.value.email, 'email');
    handleEmailSubmit(form.value.email);
  } catch (err) {
    if (err instanceof ValidationError) {
      errors.value = err.inner.map(error => ({
        key: error.path as string,
        value: error.message
      }));
    }
    isLoading.value = false;
  }
}

function getInputStatus(key: string) {
  return errors.value.find(error => error.key === key)
    ? InputStatusType.Error
    : InputStatusType.Default;
}

function getErrorMessage(key: string) {
  return errors.value.find(error => error.key === key)?.value || '';
}

function clearErrors() {
  errors.value = [];
}

function redirectToSignup() {
  trackSignupLink();
  router.push({ name: 'signup' });
}

return { __sfc: true,setTheme, handleEmailSubmit, errors, router, isLoading, form, disableButton, validate, getInputStatus, getErrorMessage, clearErrors, redirectToSignup, BaseText, ButtonPrimary, Heading, InputText, Link, trackEmailEvent, NebraskaColors }
}

})